import {dependencies} from "./dependencies.mjs";
import {loggerFactory} from "@mecatran/logger-factory";
import request from "browser-request";

console.log('index.browser');
dependencies.target = 'browser';
dependencies.request = request; 
dependencies.loggerFactory = loggerFactory;





